import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { addUser } from "../../store/addUserSlice";
import { setShowAlert, updateCreditStatus } from "../../store/addUserSlice";
import Loader from "../componants/Loader";

const AddUser = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [product, setProduct] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [productError, setProductError] = useState(false);
  const [allData, setAllData] = useState("");
  const {
    userData = {},
    userStatus,
    showAlert,
  } = useSelector((state) => state.addUser);

  const handleLogin = () => {
    let isValid = true;
    if (!username) {
      setUsernameError(true);
      isValid = false;
    }
    if (!password) {
      setPasswordError(true);
      isValid = false;
    }
    if (!product) {
      setProductError(true);
      isValid = false;
    }
    if (isValid) {
      setAllData({ username, password, product, subscribed: "" });
    }
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (allData) {
      dispatch(addUser(allData));
    }
  }, [allData]);

  useEffect(() => {
    if (userData) {
      dispatch(updateCreditStatus({ status: false }));
      setUsername("");
      setPassword("");
      setProduct("");
    }
  }, [userData, dispatch]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(setShowAlert());
  };
  console.log(userStatus);
  if (userStatus === "loading") {
    return <Loader />;
  }

  return (
    <>
      <Typography variant="h5" sx={{ my: 4, mx: 5 }}>
        Add User
      </Typography>
      <Stack
        justifyContent={"center"}
        width={"100%"}
        spacing={4}
        alignItems={"center"}
      >
        <TextField
          sx={{ width: "70%" }}
          autoFocus
          margin="dense"
          placeholder="Ex- GBK@1234"
          id="username"
          label="Username"
          type="text"
          fullWidth
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
            setUsernameError(false);
          }}
          error={usernameError}
          helperText={usernameError && "Username is required"}
        />
        <TextField
          sx={{ width: "70%" }}
          margin="dense"
          placeholder="Ex- GBK1"
          id="password"
          label="Password"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setPasswordError(false);
          }}
          error={passwordError}
          helperText={passwordError && "Password is required"}
        />
        <TextField
          sx={{ width: "70%" }}
          margin="dense"
          placeholder="Ex- KYC/ReKYC/IPO"
          id="product"
          label="Product"
          type="text"
          fullWidth
          value={product}
          onChange={(e) => {
            setProduct(e.target.value);
            setProductError(false);
          }}
          error={productError}
          helperText={productError && "Product is required"}
        />

        <Button
          variant="contained"
          sx={{ width: "70%" }}
          onClick={handleLogin}
          color="primary"
        >
          Submit
        </Button>
      </Stack>

      <Snackbar
        open={showAlert || userStatus === "error" ? true : false}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{
          background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
          color: "white",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={userStatus === "error" ? "error" : "success"}
          sx={{ width: "100%" }}
        >
        
          {userStatus === "error"
            ? "Something went wrong"
            : "User Added Successfully !"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddUser;
